import { useOnlineStatus } from '@/hooks/useOnlineStatus';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { WifiOff, Wifi } from 'lucide-react';

export const OfflineBanner = () => {
  const { isOnline, wasOffline } = useOnlineStatus();

  if (isOnline && !wasOffline) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-50 animate-fade-up"
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      <Alert
        variant={isOnline ? 'default' : 'destructive'}
        className="rounded-none border-x-0 border-t-0"
      >
        {isOnline ? (
          <>
            <Wifi className="h-4 w-4" aria-hidden="true" />
            <AlertDescription>
              You're back online! Data is being synchronized.
            </AlertDescription>
          </>
        ) : (
          <>
            <WifiOff className="h-4 w-4" aria-hidden="true" />
            <AlertDescription>
              You're offline. Some features may be limited.
            </AlertDescription>
          </>
        )}
      </Alert>
    </div>
  );
};
